import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { examsInCity } from './_consts/exams-in-city.const';
import { specialtiesInCity } from './_consts/specialties-in-city.const';

import { filterProceduresBySlug } from '@/app/(main)/(pages)/(institucional)/(index)/_utils/procedures.util';
import { Card } from '@/components/ui/card.component';
import { ContentContainer } from '@/components/ui/content-container.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

interface IndexProceduresInCityProps {
  type: 'exames' | 'especialidades';
  city: string;
  citySlug: string;
  procedureSlug: string;
}

export function IndexProceduresInCity({ type, city, citySlug, procedureSlug }: IndexProceduresInCityProps) {
  const label = type === 'exames' ? 'Exames' : 'Especialidades';
  const items = type === 'exames' ? examsInCity : specialtiesInCity;
  const filteredItems = filterProceduresBySlug(procedureSlug, items);

  return (
    <div className="md:mb-10 xl:mt-10 xl:max-w-80 w-full border border-x-0 md:border-0">
      <ContentContainer>
        <Card className="border-0 shadow-none p-0 bg-gray-50 md:bg-white md:border md:shadow-tooltip md:px-6 md:pt-0 xl:w-80">
          <div data-testid={DataTestIdEnum.INDEX_PROCEDURES_IN_CITY_TITLE} className="bg-green-100 w-fit px-5 py-1 mb-4 rounded-sm">
            <Typography variant={TypographyVariant.BODY_TEXT} className="font-semibold text-wrap text-center">
              {`${label} em ${city}`}
            </Typography>
          </div>

          <ul className="space-y-2 mb-4">
            {filteredItems.map((procedure, index) => (
              <li key={procedure.slug} className="text-green-500 font-bold">
                <Link
                  prefetch={false}
                  href={`/${type}/${procedure.slug}-em-${citySlug}/`}
                  data-testid={DataTestIdEnum.INDEX_PROCEDURES_IN_CITY_LINK}
                  className="hover:underline"
                >
                  {procedure.name}
                </Link>
                {index < filteredItems.length - 1 && <hr className="my-2 border-gray-200" />}
              </li>
            ))}
          </ul>
        </Card>
      </ContentContainer>
    </div>
  );
}
